import { EMPTY_LIST } from '../../../../constants/common'
import { getQaSelector } from '../../../../utils/common'
import { getIsListingArchivable } from '../../../RentalPortalListing'

import {
  LISTING_BOARD_COLUMN_ORDER,
  QA_NAME_LISTING_BOARD,
} from './RentalPortalListingsBoard.constants'
import {
  getIsListingsBoardEmpty,
  getListingsBoardColumnTotal,
  getListingsByStatus,
} from './RentalPortalListingsBoard.utils'
import { RentalPortalListingsBoardColumn } from './RentalPortalListingsBoardColumn'

import * as styles from './RentalPortalListingsBoard.module.css'

function RentalPortalListingsBoard({
  activeItem,
  emptyState = null,
  getActions,
  getIsItemSelectable = getIsListingArchivable,
  hasSelection,
  isLoading,
  items,
  selectedIds,
  selectNotAllowedTooltip,
  statistic,
  onCallAction,
  onClickCard,
  onSelectCard,
  onSelectColumn,
  onShowMore,
}) {
  const listingsByStatus = getListingsByStatus(isLoading ? EMPTY_LIST : items)

  const qaProps = getQaSelector({ value: QA_NAME_LISTING_BOARD })

  return (
    <div {...qaProps} className={styles.RentalPortalListingsBoard}>
      <div className={styles.columns}>
        {LISTING_BOARD_COLUMN_ORDER.map(status => (
          <RentalPortalListingsBoardColumn
            activeItem={activeItem}
            getActions={getActions}
            getIsItemSelectable={getIsItemSelectable}
            hasSelection={hasSelection}
            isLoading={isLoading}
            items={listingsByStatus[status]}
            key={status}
            selectedIds={hasSelection ? selectedIds : EMPTY_LIST}
            selectNotAllowedTooltip={selectNotAllowedTooltip}
            status={status}
            total={getListingsBoardColumnTotal({
              items: listingsByStatus[status],
              statistic,
              status,
            })}
            onCallAction={onCallAction}
            onClickCard={onClickCard}
            onSelectCard={onSelectCard}
            onSelectColumn={onSelectColumn}
            onShowMore={onShowMore}
          />
        ))}
      </div>
      {getIsListingsBoardEmpty({ isLoading, items }) ? emptyState : null}
    </div>
  )
}

export default RentalPortalListingsBoard
